import React, { useEffect, useState } from 'react'
import ModalCustom from '../../../components/modal-custom'
import { Button, Col, Form } from 'react-bootstrap'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import LabelCustom from '../../../components/label-custom'
import Autocomplete from '../../../components/custom/autocomplete'
import { BsExclamationCircle } from 'react-icons/bs'
import CustomDatePicker from '../../../components/custom/CustomDatePicker'
import InputPriceCustom from '../../../components/custom/InputPriceCustom'
import { useDebounce } from '@react-hook/debounce'
import AutocompleteCustom from '../../../components/custom/autocomplete'
import {
  createIncomeAPI,
  deleteIncomeAPI,
  updateIncomeAPI
} from '../../../services/income/payment'
import UsePaymentTypeIncome from '../../../hooks/use-payment-type'
import { TXTSUCCESS } from '../../../Constants'
import Error_false from '../../../components/error/error-false'
import SwalCustom from '../../../alert/swal-custom'
import { fnDateEn } from '../../../helper/fnDateEn'
import UseSearchEmployeePayment from '../../../hooks/use-emps-payment'
import UsePaymentListIncome from '../../../hooks/use-payment-list'

const schema = yup
  .object({
    username: yup.object().required('Please choose your username.'),
    payment: yup.object().required('Please choose your type.'),
    date: yup.string().required('Please choose your date.'),
    amount: yup.string().required('Please choose your date.')
  })
  .required()
export default function ModalUpdateIncome({
  open,
  onCancel,
  fnGetData,
  data,
  orgId
}) {
  const menuType = 1
  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })
  const [searchs, setSearchs] = useDebounce('', 1000)
  const empOption = UseSearchEmployeePayment(orgId, searchs)
  const payments = UsePaymentListIncome(menuType)
  const [isSubmit, setIsSubmit] = useState(false)
  const [dataType, setDataType] = useState()
  const paymentTypeIncome = UsePaymentTypeIncome()
  const [menuTypeData, setMenuTypeData] = useState()

  useEffect(() => {
    if (paymentTypeIncome.length > 0) {
      const _type = paymentTypeIncome.find((item) => item.value === menuType)
      // setValue('paymentListType', _type)
      setMenuTypeData(_type)
    }
    if (data) {
      const user = {
        orgId: data.orgId,
        code: data.code,
        value: data.code,
        label: `${data?.org ?? ''} - ${data?.code ?? ''} - ${data?.titleTh}${
          data?.nameTh ?? ''
        } ${data?.surnameTh ?? ''}`
      }
      setValue('username', user)
      setValue('amount', data.paymentAmounts)
      data.paymentPeriodDate &&
        setValue('date', new Date(data.paymentPeriodDate))

      const _payment = {
        value: data.paymentListId,
        label: `${data?.paymentName ?? ''}`,
        dataTypeName: data.dataTypeName
      }
      setValue('payment', _payment)

      setDataType(_payment)
    }
  }, [paymentTypeIncome, setValue, data])

  const onSubmit = async (d) => {
    const body = {
      orgId: d.username.orgId,
      code: d.username.code,
      paymentAmounts: +d.amount?.replace(/,/g, ''),
      paymentListTypeId: menuType
    }

    if (data) {
      sendAPI(
        updateIncomeAPI({
          paymentInComeId: data.paymentInComeId,
          ...body
        })
      )
    } else {
      sendAPI(
        createIncomeAPI({
          ...body,
          paymentListId: d.payment.value,
          paymentPeriodDate: fnDateEn(d.date).format('YYYY-MM-DD')
        })
      )
    }
  }

  const fnDelete = () => {
    SwalCustom({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'error',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        let body = {
          orgId,
          code: data.code,
          paymentListTypeId: menuType,
          paymentInComeId: data.paymentInComeId
        }
        sendAPI(deleteIncomeAPI(body))
      }
    })
  }

  const sendAPI = async (api) => {
    setIsSubmit(true)
    const resp = await api
    setIsSubmit(false)
    if (!resp) return
    if (resp.status) {
      SwalCustom({
        title: `Success!`,
        text: TXTSUCCESS,
        timer: 1500,
        showConfirmButton: false
      }).then(() => {
        onCancel()
        fnGetData()
      })
    } else {
      Error_false(resp)
    }
  }

  return (
    <ModalCustom
      maskClosable={false} // ป้องกันการปิดเมื่อคลิกที่ mask (backdrop)
      keyboard={false} // ป้องกันการปิดเมื่อกดปุ่ม Esc
      open={open}
      onCancel={onCancel}
    >
      <div>
        <h5>
          {data ? 'Update' : 'Add'} Income ({menuTypeData?.label})
        </h5>
        <Form className="row g-3" onSubmit={handleSubmit(onSubmit)}>
          <Col xl={12}>
            <LabelCustom text={'Payment Type'} />
            <Controller
              name={'payment'}
              control={control}
              render={({ field: { onChange, value = null } }) => (
                <Autocomplete
                  disabled={data}
                  // placeholder="Select organization"
                  options={payments}
                  value={value}
                  onChange={(e) => {
                    setDataType(e)
                    onChange(e)
                  }}
                />
              )}
            />
            {errors.payment && (
              <span className="text-danger small fw-light">
                <BsExclamationCircle /> {errors.payment.message}
              </span>
            )}
          </Col>
          <Col xl={12}>
            <LabelCustom text={'Employee'} />
            <Controller
              name={'username'}
              control={control}
              render={({ field: { onChange, value = null } }) => (
                <AutocompleteCustom
                  options={empOption}
                  value={value}
                  disabled={data}
                  onChange={onChange}
                  onInputChange={(data) => {
                    setSearchs(data)
                  }}
                />
              )}
            />
            {errors.username && (
              <span className="text-danger small fw-light">
                <BsExclamationCircle /> {errors.username.message}
              </span>
            )}
          </Col>

          <Col xl={12}>
            <LabelCustom text={'Periods'} />
            <Controller
              name={'date'}
              control={control}
              render={({ field: { onChange, value = null } }) => (
                <CustomDatePicker
                  disabled={data}
                  isClearable={!data}
                  value={value}
                  showMonthYearPicker
                  dateFormat="MM/yyyy"
                  onChange={onChange}
                  showYearDropdown
                  showMonthDropdown
                />
              )}
            />
            {errors.date && (
              <span className="text-danger small fw-light">
                <BsExclamationCircle /> {errors.date.message}
              </span>
            )}
          </Col>
          <Col xl={12}>
            <LabelCustom text={dataType?.dataTypeName ?? 'Amount'} />
            <Controller
              name={'amount'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <InputPriceCustom
                  placeholder=""
                  value={value}
                  onChange={onChange}
                />
              )}
            />
            {errors.amount && (
              <span className="text-danger small fw-light">
                <BsExclamationCircle /> {errors.amount.message}
              </span>
            )}
          </Col>

          <Col xl={12} className="d-flex justify-content-center g-3 gap-3 mt-4">
            <Button onClick={onCancel} variant="light" className="px-4">
              Close
            </Button>
            {data && (
              <Button variant="danger" className="px-4" onClick={fnDelete}>
                Delete
              </Button>
            )}
            <Button disabled={isSubmit} type="submit" className="px-4">
              Submit{isSubmit && '...'}
            </Button>
          </Col>
        </Form>
      </div>
    </ModalCustom>
  )
}
